import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import OrderDetailsHeader from './OrderDetailsHeader';
import { Col, Row } from 'reactstrap';
import OrderDetailsTable from "./orderDetailTable";
import { getOrderDetails } from 'actions/order';
import { connect } from "react-redux";
import moment from 'moment'
import AppConfig from 'constants/config'
import CircularProgress from '@mui/material/CircularProgress';
import SellerContainer from "components/sellerContainer"
import { useParams } from 'react-router-dom';
import { previewOrderCoupon, previewPayable, round2 } from 'util/campaignPreview';
import { sellerLastLogStatus } from 'util/holdForBuyer';

const OrderDetails = (props) => {
  const params = useParams()
  const [updatedProduct, setUpdatedProduct] = useState([])
  const [status, setStatus] = useState('New')
  const [orderDetailsState, setOrderDetailsState] = useState({})
  const [statusBadge, setStatusBadge] = useState('')
  const { orderDetails } = props

  useEffect(() => {
    props.getOrderDetails({ data: { orderId: params.id } })
  }, [])

  useEffect(() => {
    if (orderDetails && Object.keys(orderDetails).length > 0) {
      // sellerLastLogStatus, not raw indexing: a hold-for-buyer RELEASE writes a 'New and UnHold'
      // entry, which the seller reads as the plain 'New' the order still is - same as admin. That
      // also lets the first comparison match again, so a released order falls back to `requested`.
      const lastStatus = sellerLastLogStatus(orderDetails);
      let tempStatusBadge = orderDetails.requested === lastStatus ? orderDetails.requested : orderDetails.requested === "Requested" ? "Requested" : orderDetails.requested === "Approved" ? "Approved" : lastStatus;
      setStatus(orderDetails.requested)
      setOrderDetailsState(orderDetails)
      setStatusBadge(tempStatusBadge)
    }
  }, [orderDetails])

  const onClickHandle = (e, value, orderProductData) => {
    e.preventDefault();
    if (orderProductData) {
      setUpdatedProduct(orderProductData)
    }
  }

  const getValue = (data) => {
    if (!data.discount_on_product && data.discount_per > 0) {
      let totalPtr = (((data.discount_per / 100) * data.PTR) + data.PTR)
      return totalPtr * Number(data.quantity)
    } else {
      return data.PTR * Number(data.quantity)
    }
  }

  const getFinalValue = (data) => {
    let tempValue = getValue(data)
    let finalValue = ((data.inventory_id.product_id.GST.value / 100) * tempValue) + tempValue;
    return finalValue
  }

  let finalGrand = 0;
  orderDetails && orderDetails.products && orderDetails.products.map((eachProduct) => {
    return (
      finalGrand = finalGrand + Number(getFinalValue(eachProduct))
    )
  })

  /*
  The money on this card has to follow the seller's edits in the table below, not sit on the figures
  the order was placed at. `updatedProduct` is the revised line-up the change request will actually
  submit (orderDetailTable hands it up through onClickHandle), so previewing off it shows exactly
  what the API will store when the request goes through:

      total_amount        = gross incl-GST  -  product coupon      (previewPayable)
      coupon_discount     = the prorated per-line coupons          (previewOrderCoupon)
      base_total_amount   = the two added back together            (the struck-through figure)

  Until the seller touches anything `updatedProduct` is empty and the STORED figures are shown
  verbatim - the same numbers as before this preview existed. The two agree on any order that is
  still editable, since the change-request path derives total_amount from the lines by this very
  rule; keeping the stored values for the untouched case simply means an order the page never
  previewed cannot be re-stated by a display bug.

  Nothing here is submitted. The change request carries quantities only and the API recomputes all
  of it authoritatively in recalcCouponsOnRevisedOrder.
  */
  const isRevised = updatedProduct && updatedProduct.length > 0;
  const previewCoupon = isRevised ? previewOrderCoupon(updatedProduct) : Number(orderDetailsState.coupon_discount || 0);
  const previewTotal = isRevised ? previewPayable(updatedProduct) : Number(orderDetailsState.total_amount || 0);
  // The struck-through price is the pre-coupon value. Built by ADDING the coupon back, never by
  // reading base_total_amount: that field also absorbs an admin write-down, which is not a coupon.
  const previewBeforeCoupon = round2(previewTotal + previewCoupon);

  return (
    <SellerContainer>
      <div className="order-details" >
        {
          (statusBadge !== ' ') ? <Button className={statusBadge.includes("Processed") ? "text-primary" : statusBadge.includes("Ready For Dispatch") ? "text-amber" : statusBadge.includes("Placed") ? "text-yellow" : statusBadge.includes("Cancelled") ? "text-grey" : statusBadge.includes("Delivered") ? "text-green" : statusBadge.includes("Requested") ? "text-info" : statusBadge.includes("New") ? "text-danger" : "text-info"}>{statusBadge === 'Processed' ? 'Processed' : statusBadge}</Button> :
            <div className="loader-view">
              <CircularProgress />
            </div>
        }
      </div>
      {(orderDetailsState && Object.keys(orderDetailsState).length > 0) ?
        <div className="dashboard animated slideInUpTiny animation-duration-3">
          <OrderDetailsHeader
            text={props.text}
            cancelText={props.cancelText}
            status={status}
            updatedProduct={updatedProduct}
            title="Order ID"
          />
          <div className="row">
            <div className="col-12">
              <div className="jr-card chart-user-statistics bg-primary darken-4 text-white">
                <div className="orderDetails px-4 mb-4">
                  <Row className="pb-4">
                    <Col xs={12} xl={6} sm={12} md={6} lg={6} className="orderDetailsMainCol">
                      <h3 style={{ fontSize: 15 }}> ORDER PLACED BY</h3>
                      <div className="p-1">
                        <i className="zmdi zmdi-info-outline zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                        <span className="align-self-center ml-1">
                          {params.id}
                        </span>
                      </div>
                      <div className="p-1">
                        <i className="zmdi zmdi-account-o zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                        <span className="align-self-center ml-1">
                          {
                            orderDetailsState.user_id !== undefined ? orderDetailsState?.user_id?.company_name : 'N/A'
                          }
                        </span>
                      </div>
                      <div className="p-1">
                        <i className="zmdi zmdi-pin zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                        <span className="align-self-center ml-1">
                          {
                            orderDetailsState.user_id !== undefined ? orderDetailsState?.user_id?.user_address : 'N/A'
                          }
                        </span>
                      </div>
                      <div className="p-1">
                        <i className="zmdi zmdi-city zmdi-hc-fw zmdi-hc-sm text-white align-self-center" />
                        <span className="align-self-center ml-1">
                          {
                            orderDetailsState.user_id !== undefined ? orderDetailsState?.user_id?.user_city : ''
                          },&nbsp;
                          {
                            (orderDetailsState.user_id !== undefined && orderDetailsState?.user_id?.user_state !== undefined) ? orderDetailsState?.user_id?.user_state.name : 'N/A'
                          }
                        </span>
                        <p className="ml-4 mb-0">
                          {
                            orderDetailsState.user_id !== undefined ? orderDetailsState?.user_id?.user_pincode : 'N/A'
                          }
                        </p>
                      </div>
                    </Col>
                    <Col xs={12} xl={4} sm={4} md={4} lg={4} className="orderDetailsMainCol">
                      <h3 style={{ fontSize: 15 }}> KYC DETAILS</h3>
                      {orderDetailsState.user_id && orderDetailsState.user_id.drugLic20B && orderDetailsState.user_id.drugLic20B.name ?
                        <div className="p-1">
                          <span className="align-self-center ml-1">
                            FORM 20&nbsp;<span className="small">&#40;{orderDetailsState.user_id && orderDetailsState.user_id.drugLic20B && orderDetailsState.user_id.drugLic20B.expires ? `${orderDetailsState.user_id.drugLic20B.lic ? orderDetailsState.user_id.drugLic20B.lic : ''} \u007C ` + moment(orderDetailsState.user_id.drugLic20B.expires).format('DD/MM/YYYY') : ''}&#41;</span>
                          </span>
                          <span className="align-self-center ml-4 pull-right">
                            <a target='blank' download href={`${AppConfig.baseUrl}users/${orderDetailsState.user_id && orderDetailsState.user_id.drugLic20B && orderDetailsState.user_id.drugLic20B.name ? orderDetailsState.user_id.drugLic20B.name : ''}`}>
                              <i className="zmdi zmdi-cloud-download zmdi-hc-fw zmdi-hc-md text-white align-self-center" />
                            </a>
                          </span>
                        </div>
                        : ''}
                      {orderDetailsState.user_id && orderDetailsState.user_id.drugLic21B && orderDetailsState.user_id.drugLic21B.name ?
                        <div className="p-1">
                          <span className="align-self-center ml-1">
                            FORM 21&nbsp;<span className="small">&#40;{orderDetailsState.user_id && orderDetailsState.user_id.drugLic21B && orderDetailsState.user_id.drugLic21B.expires ? `${orderDetailsState.user_id.drugLic21B.lic ? orderDetailsState.user_id.drugLic21B.lic : ''} \u007C ` + moment(orderDetailsState.user_id.drugLic21B.expires).format('DD/MM/YYYY') : ''}&#41;</span>
                          </span>
                          <span className="align-self-center ml-4 pull-right">
                            <a target='blank' download href={`${AppConfig.baseUrl}users/${orderDetailsState.user_id && orderDetailsState.user_id.drugLic21B && orderDetailsState.user_id.drugLic21B.name ? orderDetailsState.user_id.drugLic21B.name : ''}`}>
                              <i className="zmdi zmdi-cloud-download zmdi-hc-fw zmdi-hc-md text-white align-self-center" />
                            </a>
                          </span>
                        </div>
                        : ''}
                      {orderDetailsState.user_id && orderDetailsState.user_id.fassaiLic && orderDetailsState.user_id.fassaiLic.name ?
                        <div className="p-1">
                          <span className="align-self-center ml-1">
                            FASSAI&nbsp;
                            {orderDetailsState.user_id && orderDetailsState.user_id.fassaiLic &&
                              <span className="small">
                                &#40;
                                {orderDetailsState.user_id && orderDetailsState.user_id.fassaiLic && orderDetailsState.user_id.fassaiLic.expires ?
                                  `${orderDetailsState.user_id.fassaiLic.lic ? orderDetailsState.user_id.fassaiLic.lic : ""} \u007C ` +
                                  moment(orderDetailsState.user_id.fassaiLic.expires).format('DD/MM/YYYY')
                                  + '' : ''
                                }
                                &#41;</span>}
                          </span>
                          <span className="align-self-center ml-4 pull-right">
                            <a target='blank' download href={`${AppConfig.baseUrl}users/${orderDetailsState.user_id && orderDetailsState.user_id.fassaiLic && orderDetailsState.user_id.fassaiLic.name ? orderDetailsState.user_id.fassaiLic.name : ''}`}>
                              <i className="zmdi zmdi-cloud-download zmdi-hc-fw zmdi-hc-md text-white align-self-center" />
                            </a>
                          </span>
                        </div>
                        : ''}
                      {orderDetailsState.user_id && orderDetailsState.user_id.gstLic && orderDetailsState.user_id.gstLic.name ?
                        <div className="p-1">
                          <span className="align-self-center ml-1">
                            GSTN&nbsp;
                            {orderDetailsState.user_id && orderDetailsState.user_id.gstLic &&
                              <span className="small">
                                {orderDetailsState.user_id.gstLic.lic ?
                                  <React.Fragment>
                                    &#40;
                                    {orderDetailsState.user_id && orderDetailsState.user_id.gstLic ?
                                      `${orderDetailsState.user_id.gstLic.lic ? orderDetailsState.user_id.gstLic.lic : " "}` : ''}
                                    &#41;
                                  </React.Fragment>
                                  : null}
                              </span>}
                          </span>
                          <span className="align-self-center ml-4 pull-right">
                            <a target='blank' download href={`${AppConfig.baseUrl}users/${orderDetailsState.user_id && orderDetailsState.user_id.gstLic && orderDetailsState.user_id.gstLic.name ? orderDetailsState.user_id.gstLic.name : ''}`}>
                              <i className="zmdi zmdi-cloud-download zmdi-hc-fw zmdi-hc-md text-white align-self-center" />
                            </a>
                          </span>
                        </div>
                        : ''}
                      <h3 style={{ fontSize: 15, marginBottom: '0px', marginTop: '10px' }}>PAYMENT TYPE &#40;{orderDetails && orderDetails.isBulk ? 'Bulk Prepaid' : orderDetails.paymentType === 'Online' ? 'Prepaid' : orderDetails && orderDetails.paymentType}&#41;</h3>
                      <div className="p-1">
                        <span className="align-self-center ml-1">
                          Grand Total ₹{previewTotal.toFixed(2)}
                        </span>
                      </div>
                      {/* What the coupon took off - the coupon figure ITSELF, either read from
                          `coupon_discount` or previewed per line, and never derived by subtracting the
                          two totals. base_total_amount - total_amount is NOT the coupon: an admin
                          writing the order value down widens that gap, so the subtraction reported the
                          coupon plus the write-down as one figure (a ₹45 coupon on an order cut by
                          ₹147.90 displayed as "Coupon -₹192.90"). The coupon is the single figure
                          placement and every change request maintain, so it stays right whatever else
                          moves the totals - which is also why the struck-through price above is built
                          by adding it back on rather than read from base_total_amount. */}
                      {previewCoupon > 0 ?
                        <div className="p-1">
                          <span className="align-self-center ml-1 text-success" style={{ fontSize: 13 }}>
                            <span style={{ textDecoration: 'line-through', color: '#bbb' }}>
                              ₹{previewBeforeCoupon.toFixed(2)}
                            </span>
                            &nbsp;Coupon &minus;₹{previewCoupon.toFixed(2)}
                          </span>
                        </div> : ''}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <OrderDetailsTable onClickHandle={onClickHandle} cancelText={props.cancelText} />
            </div>
          </div>
        </div>
        : <div className="loader-view">
          <CircularProgress />
        </div>
      }
    </SellerContainer>
  );
}

const mapStateToProps = ({ order }) => {
  const { orderDetails, totalValue, text, cancelText } = order;
  return { orderDetails, totalValue, text, cancelText }
};

export default connect(mapStateToProps, { getOrderDetails })(OrderDetails);